import { combineEpics } from 'redux-observable';
import globalInitClientEpics from './global-init-client-epics';
import userEpics from './user-epics';
import bookingEpics from './booking-epics';
import historyEpics from './history-epics';
import bulkUploadEpics from './bulk-upload-epics';
import hydraScanEpic from './hydra-epics';
import generalEpics from './general-epics';
import shopifyEpics from './shopify-epics';
import newBookingEpics from './new-booking-epics';
// eslint-disable-next-line import/no-cycle
import newBulkUploadEpics from './new-bulk-upload-epics'; //todo: fix this circular import
import scribeEpics from './scribe-epics';
import trackGAEpics from './track-ga-epics';
import OVOEpics from './ovo-epics';
import GeoEpics from './geo-epics';
import NewHistoryEpics from './new-history-epics';
import commonEpics from './common-epics';
import scribeNewBulkUploadEpic from './scribe-new-bulk-upload-epic';
import scribeSavedPOIEpic from './scribe-saved-poi-epics';

export default combineEpics(
  commonEpics,
  globalInitClientEpics,
  userEpics,
  bookingEpics,
  historyEpics,
  bulkUploadEpics,
  hydraScanEpic,
  generalEpics,
  shopifyEpics,
  newBookingEpics,
  newBulkUploadEpics,
  scribeEpics,
  trackGAEpics,
  OVOEpics,
  GeoEpics,
  NewHistoryEpics,
  scribeNewBulkUploadEpic,
  scribeSavedPOIEpic,
);
